require('./index.css');


var arr = ["QQ_BROWSER","QQ_MAIL","WECHAT","TENCENT_QQ","TENCENT_UNIVERSITY","KING_HONOR"]

$(document).on('click', 'a[data-fid]', function (e) {

  var vid = $(this).attr('data-fid');
  _qblog.wsd.click('TRANSLATESYNCSPREAD.' + arr[vid-1]);
});




// WEBPACK FOOTER //
// ./modules/footer/index.js